// extracted by mini-css-extract-plugin
module.exports = {"cp-portal-footer":"styles_cp-portal-footer__2-llV","cp-portal-footer__logo":"styles_cp-portal-footer__logo__YnFzH"};